import { render, staticRenderFns } from "./PageParkingAccess.vue?vue&type=template&id=2a38e5a6&scoped=true"
import script from "./PageParkingAccess.vue?vue&type=script&lang=ts"
export * from "./PageParkingAccess.vue?vue&type=script&lang=ts"
import style0 from "./PageParkingAccess.vue?vue&type=style&index=0&id=2a38e5a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a38e5a6",
  null
  
)

export default component.exports